import React, {PureComponent} from "react"
import PropTypes from "prop-types"

import {InfoWindow as DefaultInfoWindow} from "@irati-web/geolocation/src/components/GeoMap"

import {StyledAddress} from "./styled/InfoWindow"

class InfoWindow extends PureComponent {
  render() {
    const {className, arrowPosition, streetAddress, city, postCode} = this.props
    return (
      <DefaultInfoWindow className={className} arrowPosition={arrowPosition}>
        <StyledAddress title={streetAddress} city={city} postCode={postCode} />
      </DefaultInfoWindow>
    )
  }
}

InfoWindow.propTypes = {
  className: PropTypes.string,
  arrowPosition: PropTypes.oneOf([
    "top",
    "right",
    "bottom",
    "left"
  ]),
  streetAddress: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  postCode: PropTypes.string.isRequired
}

InfoWindow.defaultProps = {
  className: null,
  arrowPosition: "top"
}

export default InfoWindow
